import styled from '@emotion/styled';
import { BASE_COLORS, COLORS } from "../../constants/Theme";
import { StyledDropdown } from '../floating-action-button';
export const AnalyticsChipContainer = styled.div `
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	padding: 12px 16px;
	gap: 8px;
	background: ${(props) => props.backgroundColor};
	border-radius: 8px;
	width: ${(props) => (props.width ? props.width : '224.67px')};
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: initial;
	min-height: 88px;
	.sub--container {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		gap: 4px;
		align-items: baseline;
	}
`;
export const AnalyticsMultiWrapper = styled.div `
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	padding: 0px;
	gap: 16px;
	flex-wrap: wrap;
`;
export const MainDropdown = styled(StyledDropdown) `
	.main--dropdown.dropdown-toggle::after {
		display: unset !important;
	}
	.main--dropdown.dropdown-toggle::before {
		display: unset !important;
	}
	.main--dropdown.btn-primary:hover,
	.main--dropdown.btn-primary:active,
	.main--dropdown.btn-primary:focus,
	.main--dropdown.btn-primary.dropdown-toggle,
	.main--dropdown.show > main--dropdown.btn-primary.dropdown-toggle {
		border: 1px solid ${BASE_COLORS.grayscale[200]};
		border-radius: 4px;
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 6px 8px;
		gap: 8px;
		background: ${(props) => props.bgColor};
	}
	.dropdown-menu {
		border-radius: 3px;
		padding: 0 0;
	}
	.sub--dropdown.btn-primary {
		width: 100%;
		padding: 0px;
	}
	.sub--dropdown {
		button {
			border-radius: 0;
			max-width: 100%;
			padding: 10px 6.6667px;
			background: none;
			text-align: center;
			line-height: 16px;
			border: none;
			justify-content: center;
			align-items: center;
		}
	}
`;
export const ItemMenuContainer = styled.div `
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 12px 16px;
	gap: 4px;
	border-bottom: ${(props) => props.isLastItem ? 'none' : `1px solid ${BASE_COLORS.grayscale[200]}`};
	max-width: 240px;
	cursor: pointer;
	background-color: ${(props) => props.isSelected ? BASE_COLORS.positive[50] : BASE_COLORS.grayscale.white};
	&:hover {
		background-color: ${(props) => props.isSelected ? '' : BASE_COLORS.grayscale[50]};
	}
	width: 100%;
	border-top-left-radius: ${(props) => (props.isFirstItem ? '4px' : '0px')};
	border-top-right-radius: ${(props) => (props.isFirstItem ? '4px' : '0px')};
	border-bottom-left-radius: ${(props) => (props.isLastItem ? '4px' : '0px')};
	border-bottom-right-radius: ${(props) => (props.isLastItem ? '4px' : '0px')};
`;
export const AnalyticsTrendContainer = styled.div `
	border: ${(props) => (props.card ? 1 : 0)}px solid ${COLORS.background.base};
	height: 100%;
	${(props) => props.card
    ? `
			box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08);
			border-radius: 8px;
			padding: 16px 20px;`
    : ''}
	.icon--holder {
		height: 32px;
		width: 32px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 5px;
		cursor: pointer;
		:hover {
			background-color: ${COLORS.surface.hovered};
		}
	}
`;
export const IconContainer = styled.div `
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	background-color: ${COLORS.background.brandLight};
	border-radius: 4px;
`;
//# sourceMappingURL=CommonStyles.js.map